
	import {
		Component,
		Vue,
    Prop,
    Watch
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import LogisticsSelect from '@/views/logistics/components/select.vue';
	import {
		freightTemplateInfo,
		freightTemplateSave
	} from '@/api/logistics';
	import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';


	@Component({
		name: 'logistics-template-detail',
		components: {
			PageFooter,
			LogisticsSelect,
			'slz-message': Message,
      'slz-dialog': Dialog,
		},
		filters: {
			analysisArea(val: any) {
				const list: any = []
				val && val.map((res: any) => {
					const arr: any = []
					arr[0] = res.province
					if (res.city) arr[1] = res.city
					if (res.county) arr[2] = res.county
					list.push(arr.toString())
				})
				return list.join(';')
			}
		}
	})
	export default class LogisticsTemplateDetail extends Vue {
    @Prop({default:false}) show:boolean

		private providerId = +this.$route.query.providerId || '';
		private list: any = []
		private templateName = '';
		private payWay = 0;
		private isShowDialog = false;
		private oprType = 0;
		private region: any = [];
		private not_send_region: any = [];
		private showConfirm = false;
		private selectArea: any = [];
		private disableDate:any = []
		private isEdit: boolean = false;
		private editIndex = 0;
		private explainimgShow = false
    private diaShow = false
    private loading = false

    @Watch('show')
    private watchShow(val){
      this.diaShow = val
      if(val){
				this.init()
      }
    }
		private mounted() {

		}



		private init(){
			this.templateName = ''
			this.payWay = 0
			this.region = []
			this.not_send_region = []
		}
		/**
		 * 分析地址
		 */
		private analysisArea(val: any) {
			const list: any = []
			val.map((res: any) => {
				const arr: any = []
				arr[0] = res.province
				if (res.city) arr[1] = res.city
				if (res.county) arr[2] = res.county
				list.push(arr)
			})
			return list
		}

		private toEdit(row: any, type: number, index: number) {
			this.oprType = type;
			// console.log(type)
			// console.log(row,1)
			let selectArea = row.map(v=>{
				return v.split('-')
			})
			let disableDate:any = []
			// this.selectArea = this.analysisArea(row);
			this.editIndex = index + 1;
			this.selectArea = JSON.parse(JSON.stringify(selectArea))
			// console.log(selectArea,'selectArea')

			disableDate = this.getdisData()
			// console.log(disableDate,'dis')
			this.disableDate = JSON.parse(JSON.stringify(disableDate))
			// console.log(this.selectArea,this.disableDate,999)
			this.isShowDialog = true;
			console.log(this.disableDate,this.selectArea,'edit')
		}

		private selectDialog(type: number) {
			//0是可配送区域
			this.editIndex = 0;
			this.isShowDialog = true;
			this.isEdit = false;
			this.oprType = type;
			this.selectArea = []
			this.disableDate = []
			this.disableDate = this.getdisData()
			console.log(this.disableDate,this.selectArea,'push')

		}

		private getdisData(){
			let newdis = []
			let AreaNames = {AreaNames:this.not_send_region&&this.not_send_region.length?this.not_send_region[0].name:[]}
			newdis = this.region.concat(this.region,AreaNames)
			// console.log(newdis,'newdis')
			let disableDate = newdis.map(v=>{
				let list = v.AreaNames.map(x=>{
					return x.split('-')
				})
				// console.log(list,1)
				return list
			}).filter(v=>{
				let ishave = this.selectArea.some(m=>{
					// console.log(m[0],v[0],9999999)
					return v[0]&&m[0]==v[0][0]})
				return !ishave
			}).flat()

			return disableDate
		}

		private selectConfirm(msg: any) {
			let selectArea = []
			let data = JSON.parse(JSON.stringify(msg))
			// console.log(data.list)
			if(!data.list||!data.list.length){
				this.$message.error('请选择地区')
				return
			}
			// return
			data.list && data.list.map((res: any) => {
				// console.log(res)
				const data: any = {}
				selectArea.push(res.join('-'))
				// selectArea.push(data)
			})
			//0是可配送区域
			if (!this.oprType) {
				//editIndex为0表示新增
				// console.log(selectArea,1)
				// console.log(this.region,2)
				for(let v of selectArea){
					let have =	this.region.find((x)=>x.name==v)
					if(have){
						continue
					}
				}
				if (this.editIndex) {
					
					let data: any = this.region[this.editIndex - 1];
					// console.log(data)
					data.AreaNames = selectArea
					this.$set(this.region, this.editIndex - 1, data)
				} else {
					// console.log(this.editIndex)
					this.region.push({
						ContinueCountToNumber: '',
						ContinueMoneyToNumber: '',
						FirstCountToNumber: '',
						FirstMoneyToNumber: '',
						AreaNames: selectArea
					})
				}
			} else {
				
				this.not_send_region = [{name:selectArea}]
			}
		}

		private doDel(index: number, type: number) {
			if (!type) {
				this.region.splice(index, 1);
			} else {
				this.not_send_region.splice(index, 1);
			}
		}

		private submit() {
			if (this.templateName === '') {
				this.$message({
					type: 'warning',
					message: '请输入模版名称'
				})
				return;
			}
			if (!this.region.length && !this.not_send_region.length) {
				this.$message({
					type: 'warning',
					message: '请配置配送区域或不可配送区域'
				})
				return;
			}
			this.handleConfirm()
		}

		private close() {
			this.$emit('close')
		}

		private handleConfirm() {
			let data: any = JSON.parse(JSON.stringify(this.region))

			if (this.region.length) {
				let isEmpty = false
				data.map((item: any) => {
					if (!item.FirstCountToNumber || !item.ContinueCountToNumber ) {
						isEmpty = true
					}
					return;
				})
				if (isEmpty) {
					this.$message("物流价格或件数不能为空")
					return
				}
			}

			this.doUpdate(data);
			
		}

		private async doUpdate(region: any) {
			try {
        this.loading = true
				let res = await freightTemplateSave({
					ProviderId: this.providerId,
					Id:0,
					TemplateName: this.templateName,
					NonDistributionAreaIds: [],
					NonDistributionAreaNames: this.not_send_region[0]?this.not_send_region[0].name:[],
					DetailList: this.region
				})
        if(res.IsSuccess){
          this.$message({
            type: 'success',
            message: '提交成功'
          })
          this.$emit('confirm')
          this.close();
        }
			} catch (err) {
				console.log(err);
			}finally{
        this.loading = false
      }
		}

		/**
		 * @func 监听输入框内容（值不能小于等于0）
		 * @param index 列表序号
		 * @param key 判断那个变量
		 */
		private watchInput(index: number, key: string) {
			if (this.region[index][key] !== '' && +this.region[index][key] <= 0) {
				this.region[index][key] = 1
			}
		}

	}
